import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from 'src/environments/environment';
import {CommonService} from '../../_services/common.service';

@Injectable({ providedIn: 'root' })
export class TransactionsService {

    constructor(private http: HttpClient, private commonService: CommonService) {
    }
    getAllActiveReservations(status: string,chargeboxId: any)  {
        return this.commonService.getCall(`${environment.API_BASE_PATH}/reservations/findall?flag=${status}&chargeboxId=${chargeboxId}`);
    }

    getAllActiveTransactions(status: string, chargeboxId: any)  {
        return this.commonService.getCall(`${environment.API_BASE_PATH}/charging/findChargingSessionsByStatus/${status}?chargeboxId=${chargeboxId}`);
    }
}
